<script>

	import { range } from 'lodash'

	const Resources = {
		functional: true,
		render (h, ctx) {
			return (
				<div class="resources">
					{ctx.children}
					{range(3).map(() => <div class="resources__item blank" />)}
				</div>
			)
		}
	}

	Resources.Item = {
		functional: true,
		props: {
			image: [String],
			title: [String, Object],
			description: [String, Object],
			cta: [Object, Array]
		},
		render (h, ctx) {
			return (
				<div class="resources__item">
					{ctx.props.image && (
						<div class="resources__image">
							<img src={ctx.props.image} />
						</div>
					)}
					<div class="resources__title">{ctx.props.title}</div>
					<div class="resources__description">{ctx.props.description}</div>
					<div class="resources__ctas">{ctx.props.cta}</div>
				</div>
			)
		}
	}

	Resources.Item.Cta = {
		functional: true,
		props: {
			label: [String, Object],
			video: Object,
			to: [String, Object]
		},
		render (h, ctx) {
			const { $store } = ctx.parent
			const component = {
				data: {...ctx.data}
			}
			if(ctx.props.video) {
				component.class = 'button'
				component.data.attrs.type = 'button'
				component.data.on = {
					click () {
						$store.commit('app/setActiveVideoModal', ctx.props.video)
					}
				}
			} else if(ctx.props.to) {
				component.class = 'router-link'
				component.data.props = {
					to: ctx.props.to
				}
			} else {
				component.class = 'a'
				component.data.attrs.target = '_blank'
			}
			return (
				<component.class class="resources__cta" {...component.data}>
					{ctx.props.label}
				</component.class>
			)
		}
	}

	export default Resources

</script>

<style lang="scss" scoped>

	@import "media.scss";
	@import "responsive-font.scss";

	.resources {
		--cta-height:2em;
		display:flex; flex-wrap:wrap; margin:-1.5rem;
		/deep/ {
			.resources {
				&__item {
					display:flex; flex-direction:column; flex:1; flex-basis:100%; box-shadow:0 0 7px 0 rgba(#000, 0.20); margin:1.5rem; padding:2rem; background:#fff; text-align:center;
					@include media(xlarge) {
						flex-basis:calc(33.3333% - 3rem);
					}
					&.blank {
						box-shadow:none; height:0; overflow:hidden; margin-top:0; margin-bottom:0; padding:0;
					}
				}
				&__title {
					font-family:'oswald'; text-transform:uppercase; font-size:125%;
				}
				&__description {
					font-size:90%; margin-top:.5rem;
				}
				&__ctas {
					margin-top:auto; padding-top:1rem;
				}
				&__cta {
					display:block; width:100%; border:none; background:#fdb913; height:var(--cta-height); line-height:var(--cta-height); text-align:center; color:#fff; font-weight:600; border-radius:calc(var(--cta-height) / 2); margin-top:1rem; text-decoration:none; cursor:pointer; outline:none;
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/RemoteResources/Resources/index.vue